module Meevo.Plugins.Register {
    export class SelfPaymentModalController {
        static $inject = ["selfPaymentId",
            "meevo.components.common.DataService",
            "registerContext",
            "meevo.components.modal.ModalService",
            "sale"];
        selfPayment;
        constructor(selfPaymentId, private dataService: Meevo.Components.BaseClasses.IDataService,
            private registerContext, private modalService: Meevo.Components.Modal.IModalService,
            private sale) {
            this.dataService.customMethodData(`/api/selfPayment/${selfPaymentId}`, "get", {}).then(response => {
                this.selfPayment = response.data;
            });
        }
        close(response: boolean = false) {
            this.modalService.hideWithResponse(response);
        }
        resend(isValid) {
            if (!isValid) {
                return;
            }
            this.selfPayment.updateExpirationDate = true;
            this.registerContext.dataService.customMethodData("/api/selfPayment", "put", this.selfPayment).then(() => {
                this.close(true)
            }).catch(ex => {
                if (ex.data && ex.data.responseStatus && ex.data.responseStatus.message === "MESSAGE_SELF_PAY_INVALID_CONTACT_INFO" &&
                    this.selfPayment.refreshClient) {
                    this.selfPayment.refreshClient();
                }
            });
        }
    }
    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.SelfPaymentModalController", SelfPaymentModalController);
}